import { Component, forwardRef, input, output, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { HtlmActionStatus } from '@helpers/html/action-status';
import { copyToClipboard } from '@common/clipboard-utils';
import { AppButtonComponent } from '@view/shared/molecules/button/button.component';
import { UploadIssue } from '@model/bulk-load/upload-result.model';
import { AppTranslationPipe } from '@adapter/i18n/app-translation.pipe';
import { KEY_MESSAGE } from '@view/shared/constants/message.const';

@Component({
  selector: 'app-processing-load',
  imports: [AppButtonComponent, RouterLink, AppTranslationPipe],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProcessingLoadComponent),
      multi: true
    }
  ],
  templateUrl: './processing-load.component.html',
  styleUrls: ['./processing-load.component.scss']
})
export class ProcessingLoadComponent {
  state = input<HtlmActionStatus>(HtlmActionStatus.Loading);
  errorUploadFile = input<UploadIssue | null>(null);
  loadId = input<string | null>(null);
  newLoad = output<void>();
  retryLoad = output<void>();
  downloadTemplateWithErrors = output<void>();
  copied = signal(false);

  hasRateLimitExceededError(): boolean {
    return (
      this.errorUploadFile()?.codes?.some(
        ({ key }) => key === KEY_MESSAGE.RATE_LIMIT_EXCEEDED_CODE
      ) ?? false
    );
  }

  copyLoadId(): void {
    const value = this.loadId();
    if (!value) return;
    copyToClipboard(value, () => {
      this.copied.set(true);
      setTimeout(() => this.copied.set(false), 1000);
    });
  }
}
